module.exports = __webpack_public_path__ + "img/historia12.12a6c358.jpg";